import React from "react";
import GuestSelect from "../GuestSelect/GuestSelect";
import DateHelper from "../DateHelper/DateHelper";
import PromoCodeInput from "../PromoCodeInput/PromoCodeInput";
import ReservationBuilderActions from "./actions/ReservationBuilderActions";
import DateRangePicker from "../DateRangePicker/DateRangePicker";
import DatePickerInput from '../DatePickerInput/DatePickerInput';
import Switch from "../Switch/Switch";

export default class ReservationBuilderDateSelector extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      groupCode: "",
      groupCodeError: null,
      groupLoading: false,
      groupVisible: false,
    };

    this.onGroupDone = this.onGroupDone.bind(this);
    this.onChangeGroupCode = this.onChangeGroupCode.bind(this);
    this.toggleGroupFilter = this.toggleGroupFilter.bind(this);
    this.onChangeDateInput = this.onChangeDateInput.bind(this);
    this._onChangeDate = this._onChangeDate.bind(this);
    this.onChangePromoCode = this.onChangePromoCode.bind(this);
    this.onSubmitPromoCode = this.onSubmitPromoCode.bind(this);
    this.onChangeGuestTypeCount = this.onChangeGuestTypeCount.bind(this);
  
  }

  render() {
    return (
      <div className="date-selector">
        <div className="row date-guest-type-promo-row">
          {this.props.did_init && this.props.type_of_booking != 'daily' ? (
            <DateRangePicker
              startDateLabel="check_in_date"
              endDateLabel="check_out_date"
              dateFormat={this.props.date_format}
              onChange={this._onChangeDate}
              // type_of_booking={this.props.type_of_booking}
              startDate={this.props.check_in_date}
              endDate={this.props.check_out_date}
              minDate={this.props.current_property_date}
              maxDate={this.props.maxDate}
              maxDays={29}
              pickerClasses="col-md-6"
              componentVisisibleAction={this.setDateRangePickerVisibility}
            />
          ) : null}
          
          {this.props.did_init && this.props.type_of_booking == "daily" ? (
            <div className="flexed DateRangePicker col-md-6">
              <div className="col-sm-6 start-date-wrapper">
                <label style={{ position: "relative", top: "6px", fontSize: "12px" }}>
                  {I18n.t('check_in_date')}
                </label>
                  <DatePickerInput
                    selectedDate={this.props.check_in_date || ''}
                    dateFormat={this.props.date_format}
                    onChange={this._onChangeDate} />
              </div>
            </div>
            // hasError={this.renderFieldClasses("begins", true)} />
          
          ) : null}

          <div className="col-md-6 flexed guest-promo-column">
            <div className="res-builder-guest-select-wrapper">
              <label>{I18n.t("guests")}</label>
              <GuestSelect
                guests={this.props.guests}
                guest_types={this.props.guest_types}
                onChange={this.onChangeGuestTypeCount}
              />
            </div>

            <div className="res-builder-promo-code-wrapper">
              <label>{I18n.t("special_rates")}</label>
              <PromoCodeInput
                labeled={false}
                value={this.props.promo_code}
                promo_rates_list_path={this.props.promo_rates_list_path}
                onChange={this.onChangePromoCode}
                onSubmit={this.onSubmitPromoCode}
              />
            </div>
          </div>
          <br />
        </div>
        {
          this.props.allow_booked_at ? (
            
            <div className="row date-guest-type-promo-row">
              <div className="flexed DateRangePicker col-md-6">
                <div className="col-sm-6 start-date-wrapper">
                  <label style={{ position: "relative", top: "6px", fontSize: "12px" }}>Booked At</label>
                    <DatePickerInput
                      selectedDate={this.props.booked_at || this.props.today}
                      dateFormat={this.props.date_format}
                      // classNames={this.renderFieldClasses("start_date")}
                      onChange={this.onChangeBookedAt}
                      minDate={DateHelper.parseDateFromBackend(
                        this.props.current_property_date
                      )}
                  />
                </div>
              </div>
            </div>
           ) : 

              null
          }


        {/* <div className="row">{this.renderGroupFilter()}</div> */}
      </div>
    );
  }

  

  renderGroupFilter() {
    if (this.state.groupVisible) {
      return (
        <div className="group-filter">
          {I18n.t("group")}{" "}
          <input
            autoComplete="off"
            type="text"
            name="group_code"
            value={this.state.groupCode}
            onChange={this.onChangeGroupCode}
            className="form-control input-sm group-input"
            style={{ marginRight: "-12px" }}
          />
          <button
            type="button"
            onClick={this.onGroupDone}
            className="btn btn-primary btn-xs done-btn"
          >
            {I18n.t("done")}
          </button>
          {this.state.groupCodeError ? (
            <div className="error">{this.state.groupCodeError}</div>
          ) : null}
          {this.state.groupLoading ? (
            <div className="loadingOverlay">
              <div className="spinner spinner-sm"></div>
            </div>
          ) : null}
        </div>
      );
    } else {
      return (
        <div className="group-filter" style={{ marginTop: "3px" }}>
          {I18n.t("group")}:{" "}
          {this.props.group_contract ? (
            this.props.group_contract.code
          ) : (
            <em>({I18n.t("none")})</em>
          )}
          <button
            type="button"
            onClick={this.toggleGroupFilter}
            className="btn btn-link btn-xs edit-btn"
          >
            {I18n.t("edit")}
          </button>
        </div>
      );
    }
  }

  /**
   * Change handlers
   */

  onChangePromoCode(e, refreshAccommodations) {
    if (e && e.stopPropagation && e.preventDefault) {
      e.stopPropagation();
      e.preventDefault();
    }
    ReservationBuilderActions.changePromoCode(
      e.target.value,
      refreshAccommodations
    );
  }

  onSubmitPromoCode(e) {
    if (e && e.stopPropagation && e.preventDefault) {
      e.stopPropagation();
      e.preventDefault();
    }
    ReservationBuilderActions.submitPromoCode();
  }

  onChangeGuestTypeCount(e) {
    let guest_type_id = e.target.name;
    let number_of_guests = parseInt(e.target.value);
    ReservationBuilderActions.changeGuestTypeCount(
      guest_type_id,
      number_of_guests
    );
  }

  onGroupDone() {
    var self = this;

    if (!this.state.groupCode || this.state.groupCode == "") {
      this.setState(
        { groupLoading: false, groupCodeError: null, groupVisible: false },
        () => {
          ReservationBuilderActions.applyGroupContract(null);
        }
      );
    } else {
      this.setState({ groupLoading: true, groupCodeError: null });

      $.ajax({
        type: "POST",
        url: this.props.validate_group_contract_path,
        data: {
          group_code: this.state.groupCode,
        },
      }).done(function (data) {
        if (data && data.error) {
          self.setState({ groupLoading: false, groupCodeError: data.error });
        } else if (data && data.group_contract && data.success) {
          self.setState(
            { groupLoading: false, groupCodeError: null, groupVisible: false },
            () => {
              ReservationBuilderActions.applyGroupContract(data.group_contract);
            }
          );
        }
      });
    }
  }

  toggleGroupFilter() {
    this.setState({ groupVisible: !this.state.groupVisible });
  }

  onChangeDateInput(event) {
    var eventDate = Date.parse(event.target.value);

    if (event.target.name.indexOf("check_in_date") != -1 && eventDate) {
      $("#check_in_date").datepicker("setDate", eventDate);
    } else if (event.target.name.indexOf("check_out_date") != -1 && eventDate) {
      $("#check_out_date").datepicker("setDate", eventDate);
    }
  }

  onChangeGroupCode(e) {
    this.setState({ groupCode: e.target.value });
  }


  _onChangeDate(checkInDate, checkOutDate) {
    // Check if checkInDate is an event object
    if (checkInDate && checkInDate.target && checkInDate.target.value) {
      checkInDate = new Date(checkInDate.target.value); // Convert the value to a Date object
    }
  
    // Check if checkInDate is a valid date object
    if (checkInDate instanceof Date && !isNaN(checkInDate)) {
      // If checkOutDate is an event object, calculate 1 day after checkInDate
      if (checkOutDate && checkOutDate.nativeEvent) {
        checkOutDate = new Date(checkInDate); // Create a new Date object based on checkInDate
        checkOutDate.setDate(checkInDate.getDate() + 1); // Set checkOutDate to 1 day after checkInDate
      }
    } else {
      console.error("Invalid check-in date provided.");
      return;
    }
  

  
    // Now call the function with the extracted or adjusted dates
    ReservationBuilderActions.changeDates(checkInDate, checkOutDate);
  }

  onChangeBookedAt(bookedAt) {
    ReservationBuilderActions.changeBookedAt(bookedAt);
  }

  setDateRangePickerVisibility = (visible) => {
    if (this.props.date_range_picker_visible != visible){
      ReservationBuilderActions.setDateRangePickerVisibility(visible)
    };
  };
}
